import React, { useEffect, useState } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { update_filter_datas, update_filter_tipos, clear_filters } from '../redux/actions';
import DatePicker from 'react-date-picker';
import { useHistory } from 'react-router-dom';



function FilterModal(props){
    const filterState = useSelector(state => state.mapFilter);
    
    const [localFilters, setLocalFilters] = useState({avistamentos: true, aninhamentos: true, ataques: true})
    const [dataMin, setDataMin] = useState(null)
    const [dataMax, setDataMax] = useState(null)
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() =>{
        
        setLocalFilters(filterState.tipos)
        setDataMin(filterState.datas[0])
        setDataMax(filterState.datas[1])
    }, [filterState]);

    const handleCancel = () => {
        history.goBack()
    }

    const handleClear = () => {
        dispatch(clear_filters())
        history.goBack()
    }
    

    const applyFilters = () => {
      
        dispatch(update_filter_tipos(localFilters))
        dispatch(update_filter_datas([dataMin, dataMax]))
        history.goBack()
    }

    const FilterButton = (props) => {

        const icones = {aninhamentos:'nest', avistamentos: 'gull', ataques:'ataque'}
        
        return(
            <div onClick={() => setLocalFilters({...localFilters, [props.tipo]:!localFilters[props.tipo]})}
                style={{display:'flex', flexDirection:'column', justifyContent: 'space-around', alignContent: 'center', cursor: 'pointer', border:`1px solid ${localFilters[props.tipo]?'black':'grey'}`, width:'80px', height: '80px', borderRadius:'10px'}}>
                <div style={{textAlign: 'center'}}>
                    <img src={`/app/${icones[props.tipo]}${localFilters[props.tipo]?'':'_grey'}.png`} style={{width:'42px', height:'42px', objectFit:'contain'}}/>
                </div>
                <div
                
                style={{color:localFilters[props.tipo]?'black':'grey', textAlign:'center'}}
                
                >
                    {props.label}
                </div>
            </div>
        )
    }

    return(
        <div style={{height:'100%', padding:'10px', display:'flex', flexDirection:'column', justifyContent:'space-evenly'}}> 
            <div style={{display: 'flex', justifyContent:'space-evenly'}}>
                <FilterButton tipo='avistamentos' label='Gaivotas'/>
                <FilterButton tipo='aninhamentos' label='Ninhos'/>
                <FilterButton tipo='ataques' label='Ataques'/>
                
            </div>
            <div>
                <div ><div>Data mínima</div><DatePicker name='dataMin' id='dataMin'  value={dataMin} onChange={newDate => setDataMin(newDate)} maxDate={new Date()}  style={{width:'100%'}}/></div>
                <div><div>Data máxima</div><DatePicker name='dataMax' id='dataMax'  value={dataMax} onChange={newDate => setDataMax(newDate)} maxDate={new Date()} style={{width:'100%'}}/></div>
                </div>
            <div style={{color:'blue', cursor: 'pointer', textAlign: 'center'}} onClick = {handleClear}>Limpar todos os filtros</div>
            <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                <div onClick={handleCancel} style={{cursor: 'pointer'}}>Cancelar</div>
                <div onClick={applyFilters} style={{color: 'green', cursor: 'pointer'}}>Aplicar</div>
            </div>
        </div>
    )
}

export default FilterModal


